var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconOptionSelectDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 25,
  fill: "none",
  viewBox: "0 0 24 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M18.253 9.301a.6.6 0 0 1 0 .849L13.13 15.27a1.6 1.6 0 0 1-2.262 0l-5.12-5.12a.6.6 0 1 1 .849-.848l5.12 5.12a.4.4 0 0 0 .565 0L17.404 9.3a.6.6 0 0 1 .849 0",
  clipRule: "evenodd"
})));
export { SvgIconOptionSelectDown as ReactComponent };